export const DropdownTestIds = {
    popoverHeader: 'dropdown-select-popover-header',
    listContainer: 'dropdown-list-container',
    selectButton: 'dropdown-select-button',
    chevronUp: 'dropdown-select-chevron-up',
    chevronDown: 'dropdown-select-chevron-down',
    selectLabelText: 'dropdown-select-label-text',
    selectLabelConstantText: 'dropdown-select-label-constant-text'
};
